import axios from "axios";
import { PURCHASEEMAILS_ENDPOINT } from "./APIEndpoints";
axios.defaults.withCredentials = true;
export const sendPurchaseLink = async (CustomerId, StripeCustomerId, Email) => {
    try {
      const res = await axios.post(`${PURCHASEEMAILS_ENDPOINT}`, {CustomerId, StripeCustomerId, Email});
      console.log('------Send Purchase Email Res---------');
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.error(err.response);
      throw err;
    }
  };